import { render, staticRenderFns } from "./CatalogPageSpecial.vue?vue&type=template&id=6bca61a5&scoped=true"
import script from "./CatalogPageSpecial.vue?vue&type=script&lang=js"
export * from "./CatalogPageSpecial.vue?vue&type=script&lang=js"
import style0 from "./CatalogPageSpecial.vue?vue&type=style&index=0&id=6bca61a5&prod&lang=scss&scoped=true"
import style1 from "./CatalogPageSpecial.vue?vue&type=style&index=1&id=6bca61a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca61a5",
  null
  
)

export default component.exports